const MAX_DEVICE_RATIO = 2;

export const getDeviceRatio = () => {
  const ratio = typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1;
  return Math.min(Math.max(ratio, 1), MAX_DEVICE_RATIO);
};

export const getCanvasCssSize = (canvas) => {
  const ratio = getDeviceRatio();
  return { width: (canvas?.width || 0) / ratio, height: (canvas?.height || 0) / ratio };
};

export const scaleCanvasToRatio = (canvas, cssWidth, cssHeight) => {
  if (!canvas || !cssWidth || !cssHeight) return;
  const ratio = getDeviceRatio();
  canvas.width = Math.round(cssWidth * ratio);
  canvas.height = Math.round(cssHeight * ratio);
  canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
};

export const clearCanvas = (canvas) => {
  if (!canvas) return;
  const { width, height } = getCanvasCssSize(canvas);
  canvas.getContext('2d').clearRect(0, 0, width, height);
};

export const drawImageContained = (canvas, image) => {
  if (!canvas || !image) return;
  const ctx = canvas.getContext('2d');
  const { width, height } = getCanvasCssSize(canvas);
  ctx.clearRect(0, 0, width, height);
  const fit =
    image.width && image.height ? Math.min(width / image.width, height / image.height, 1) : 1;
  const drawWidth = image.width * fit;
  const drawHeight = image.height * fit;
  ctx.drawImage(image, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight);
};
